const loadScript: (url: string) => Promise<void> = url => {
  return new Promise((resolve, reject) => {
    const existing = document.querySelector(`[src='${url}]'`);
    if (existing) {
      resolve();
    } else {
      const scriptTag = document.createElement('script');
      scriptTag.src = url;
      scriptTag.onload = () => resolve();
      scriptTag.onerror = reject;
      document.body.appendChild(scriptTag);
    }
  });
};

export default loadScript;
